<template>
    <div>
        <LoginForm
            v-if="dialog==='login'"
            @close="onCloseDialog($event)"
            :initialOperation="initialLoginOperation"
            :initialWantsToUpgrade="initialLoginWantsToUpgrade"
        />

        <v-dialog v-model="showPricingDialog" max-width="800" content-class="pricing-dialog-shell">
            <v-card class="pricing-dialog">
                <v-card-title class="pricing-dialog__header">
                    <span>Account</span>
                    <v-spacer></v-spacer>
                    <v-btn icon small @click="dismissPricingDialog" aria-label="Close account">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <div class="pricing-dialog__account">
                    <span v-if="$store.getters.isUserLoggedIn" class="pricing-dialog__account-text">
                        Logged in as <strong>{{$store.getters.loggedInUserEmail}}</strong>.
                    </span>
                    <span v-else class="pricing-dialog__account-text">
                        Not logged in.
                    </span>
                </div>

                <v-card-text class="pricing-dialog__body">
                    <h3>Plans</h3>

                    <v-card outlined class="pricing-dialog__plan">
                        <v-card-title>
                            Free
                            <v-chip v-show="!$store.getters.isSubscribed" small class="ml-2">Current plan</v-chip>
                        </v-card-title>
                        <v-card-text>
                            <ul>
                                <li>Draw up to {{allowance('track', $store.getters.policy.freeMaxTracks)}}</li>
                                <li>Import {{allowance('GPX file', $store.getters.policy.freeImportLimit)}}</li>
                                <li>Download {{allowance('GPX file', $store.getters.policy.freeDownloadGpxLimit)}}</li>
                            </ul>
                        </v-card-text>
                    </v-card>

                    <v-progress-linear indeterminate height="8" rounded v-if="fullAccessProduct===null"></v-progress-linear>
                    <v-card outlined class="pricing-dialog__plan" v-if="fullAccessProduct !== null">
                        <v-card-title>
                            {{fullAccessProduct.name}}
                            <v-chip v-show="$store.getters.isSubscribed" small class="ml-2">Current plan</v-chip>
                        </v-card-title>

                        <v-card-text>

                                                        <v-row v-if="showMobileSubscriptionSection">
                                <v-col>
                                    <template v-if="$store.getters.isLinkedToMobileAppSubscription">
                                    <p class="pricing-dialog__largefont pricing-dialog__nobottommargin">
                                        Your web account is now successfully linked to your mobile app subscription.
                                    </p>
                                    </template>
                                    <template v-else>
                                        <p class="pricing-dialog__largefont pricing-dialog__nobottommargin pricing-dialog__mobile-subscription-heading">
                                            <span>Already subscribed / want to subscribe through the mobile app?</span>
                                            <v-tooltip bottom max-width="340">
                                                <template v-slot:activator="{on,attrs}">
                                                    <v-icon
                                                        v-on="on"
                                                        v-bind="attrs"
                                                        small
                                                        class="pricing-dialog__mobile-subscription-info"
                                                        color="primary"
                                                    >
                                                        mdi-information-outline
                                                    </v-icon>
                                                </template>
                                                <p><b>No need to pay twice if you use mobile and web!</b></p>
                                                <p>If you've already subscribed through Stripe, but want to use the mobile app as well:</p>
                                                <ul>
                                                    <li>cancel Stripe subscription</li>
                                                    <li>subscribe on mobile</li>
                                                    <li>link web app to mobile app using this link</li>
                                                </ul>
                                                <p>The web app can recognise and link to mobile app subscriptions, but not the other way round.</p>
                                                <p>Get in touch with admin@gpxplanner.app for any questions.</p>
                                            </v-tooltip>
                                        </p>
                                        <p class="pricing-dialog__mobile-subscription-link pricing-dialog__nobottommargin">
                                            <a href="#" @click.prevent="linkSubscriptionWithMobileApp">Click here to link web-app subscription with mobile app subscription</a>
                                        </p>
                                        <p>(do this on the mobile device where you've installed the app)</p>
                                    </template>
                                </v-col>
                            </v-row>


                            <v-row>
                                <v-col v-if="$store.getters.isExpired">
                                    <div>Subscription expired on <strong>{{$store.getters.expiryDateString}}</strong>.</div>
                                    <div>Please choose one of the options below to renew.</div>
                                </v-col>
                            </v-row>

                            <template v-if="$store.getters.isSubscribed">
                                <v-row v-if="$store.getters.isSubscriber">
                                    <v-col>
                                        <div>Your current subscription period runs until</div>
                                        <div><strong>{{$store.getters.expiryDateString}}</strong>.</div>
                                        <div>This will be automatically extended if you have a recurring subscription, unless you have cancelled it.</div>
                                    </v-col>
                                </v-row>
                                <v-row v-else>
                                    <v-col>
                                        You have purchased full access which expires on <strong>{{$store.getters.expiryDateStringWithTime}}</strong>
                                    </v-col>
                                </v-row>
                            </template>

                            <v-row v-if="$store.getters.isSubscribed && !!manageSubscriptionUrl">
                                <v-col>
                                    <v-btn :href="manageSubscriptionUrl" target="_blank">Manage subscription</v-btn>
                                </v-col>
                            </v-row>
                            <v-row v-else-if="!!manageSubscriptionUrl">
                                <v-col>
                                    <p class="pricing-dialog__manage-expired">
                                        {{expiredSubscriptionManageMessage}}, however you can still view details and invoice history by
                                        <a :href="manageSubscriptionUrl" target="_blank">clicking here</a>.
                                    </p>
                                </v-col>
                            </v-row>

                            <template v-if="!$store.getters.isSubscribed">
                                <v-row
                                    v-for="(price,priceIndex) in fullAccessProduct.prices"
                                    v-bind:key="`pricerow-${priceIndex}`"
                                    align="center"
                                    class="pricing-dialog__price-row"
                                >
                                    <v-col cols="7">
                                        <div><strong>{{price.description}}</strong></div>
                                        <div>{{price.nickname}}</div>
                                    </v-col>
                                    <v-col cols="5" class="pricing-dialog__price-action">
                                        <v-btn
                                            :loading="priceIdUpgrading===price.id"
                                            @click="upgrade(price, fullAccessProduct)"
                                        >
                                            {{upgradeLabel(price, fullAccessProduct)}}
                                        </v-btn>

                                        <v-tooltip bottom>
                                            <template v-slot:activator="{on,attrs}">
                                                <v-chip v-on="on" v-bind="attrs" small class="mt-1" v-if="price.allowsFreeTrial && fullAccessProduct.userHasAlreadyUsedUpFreeTrial">
                                                    <v-icon color="warning" x-small>mdi-alert</v-icon>
                                                    Free trial used
                                                </v-chip>
                                            </template>
                                            <span>
                                                Free trial is normally offered but you appear to have already used this.<br/>
                                                If you believe this to be incorrect or to request an extension please contact admin@gpxplanner.app.
                                            </span>
                                        </v-tooltip>
                                    </v-col>
                                </v-row>
                            </template>

                            <ul class="pricing-dialog__features">
                                <li>Cancel yourself at any time - <faq n="cancel" t="see here for details"/></li>
                                <li>Priority email support <a href="mailto:admin@gpxplanner.app">admin@gpxplanner.app</a></li>
                                <li>Unlimited tracks</li>
                                <li>Save routes in your own private cloud</li>
                                <li>Share routes via URL</li>
                                <li>Save routes as GPX files</li>
                                <li>Tidy up routes for device compatibility</li>
                                <li>Choice of map rendering</li>
                            </ul>
                        </v-card-text>
                    </v-card>

                    <v-card outlined class="pricing-dialog__plan" v-if="fullAccessProduct!==null">
                        <v-card-text>
                            One-off access is ideal for sharing routes to the cloud for one-off events:
                            <ul>
                                <li>Public link for your route - don't have to be logged in or subscribe to view and download it</li>
                                <li>Show in your choice of map rendering</li>
                                <li>Kept for at least 6 months</li>
                                <li><faq n="cloud" t="See the FAQ for more details"></faq></li>
                            </ul>
                        </v-card-text>
                    </v-card>
                </v-card-text>
            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" :color="snackbarColor" bottom>
            {{snackbarText}}
            <v-btn text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
    </div>
</template>

<script lang="ts">
import Vue from 'vue'
import faq from '@/DocFAQLink.vue'
import IosAccountLinkService from '@/IosAccountLinkService'
import LoginForm from '@/LoginForm.vue'
import Price from '@/Price'
import Product from '@/Product'
import ProductService from '@/ProductService'
import StripeService from '@/StripeService'
import UserEventService from '@/UserEventService'
import store from '@/store'
import StorageHelper from '@/StorageHelper'

export default Vue.extend({
    name: 'PricingDialog',
    components: {
        faq,
        LoginForm
    },
    data: () => ({
        fullAccessProduct: null as Product|null,
        priceIdUpgrading: null as string|null,
        dialog: '',
        initialLoginOperation: 0,
        initialLoginWantsToUpgrade: false,
        reopenPricingAfterLogin: false,
        snackbarText: '',
        snackbar: false,
        snackbarColor: '',
        pricingOpenedAt: null as number|null,
        checkoutStarted: false,
        suppressCloseFeedback: false
    }),
    computed: {
        showPricingDialog: {
            get(): boolean {
                return store.getters.showingPricingDialog
            },
            set(newVal: boolean) {
                if(!newVal && store.getters.showingPricingDialog) {
                    this.onPricingClosed('dialog_dismissal')
                } else {
                    store.commit('showingPricingDialog', newVal)
                }
            }
        },
        manageSubscriptionUrl(): string|undefined {
            return this.fullAccessProduct?.manageSubscriptionUrl
        },
        expiredSubscriptionManageMessage(): string {
            const expiryDate = store.getters.expiryDateShortString
            return expiryDate
                ? `Your subscription expired on ${expiryDate}`
                : 'Your subscription has expired'
        },
        showMobileSubscriptionSection(): boolean {
            const email = (this.$store.getters.loggedInUserEmail ?? '').toLowerCase()
            return /^bentaylortheonly(?:\+[^@]+)?@gmail\.com$/.test(email)
        }
    },
    watch: {
        showPricingDialog: {
            immediate: true,
            async handler(newVal: boolean) {
                if(newVal) {
                    this.pricingOpenedAt = Date.now()
                    this.checkoutStarted = false
                    this.suppressCloseFeedback = false
                    UserEventService.recordSafe('pricing_opened', {
                        source: store.getters.pricingDialogSource,
                        trialEligible: !store.getters.hasUserAlreadyUsedUpFreeTrial
                    })
                }
                if(newVal && this.fullAccessProduct === null) {
                    const productResponse = await ProductService.getFullAccessProduct()
                    this.fullAccessProduct = productResponse.data
                }
            }
        }
    },
    methods: {
        allowance(label: string, limit: number|null): string {
            if(limit === null || limit === 0) return `unlimited ${label}s`
            return `${limit} ${label}${limit === 1 ? '' : 's'}`
        },
        dismissPricingDialog() {
            this.onPricingClosed('close_button')
        },
        onPricingClosed(reason: string) {
            if(!store.getters.showingPricingDialog) return
            const displayDurationMs = this.pricingOpenedAt === null ? null : Date.now() - this.pricingOpenedAt
            UserEventService.recordSafe('pricing_closed', {
                source: store.getters.pricingDialogSource,
                reason,
                displayDurationMs,
                checkoutStarted: this.checkoutStarted
            })
            store.commit('showingPricingDialog', false)
            const promptKey = `UpgradeFeedbackPrompted:${store.getters.policy?.version || 'unknown'}`
            if(!this.suppressCloseFeedback && !this.checkoutStarted && store.getters.isUserLoggedIn &&
                !store.getters.isSubscribed && StorageHelper.getItem(promptKey) !== 'true') {
                store.commit('requestFeedbackPrompt', {
                    type: 'upgrade_blocker',
                    promptContext: 'pricing_dismissal'
                })
            }
        },
        showInfo(message: string, color = '') {
            this.snackbarText = message
            this.snackbar = true
            this.snackbarColor = color
        },
        showError(message: string) {
            this.showInfo(message, 'error')
        },
        async onCloseDialog(message: string) {
            if(message) {
                this.showInfo(message)
            }
            this.dialog = ''
            this.initialLoginWantsToUpgrade = false
            if(this.reopenPricingAfterLogin) {
                this.reopenPricingAfterLogin = false
                await this.$nextTick()
                store.commit('openPricingDialog', 'login_upgrade')
            }
        },
        offerFreeTrialForPrice(price: Price, product: Product) {
            return price.allowsFreeTrial && !product.userHasAlreadyUsedUpFreeTrial
        },
        upgradeLabel(price: Price, product: Product) {
            return this.offerFreeTrialForPrice(price, product) ? 'Free trial' : 'Buy'
        },
        async linkSubscriptionWithMobileApp() {
            try {
                const response = await IosAccountLinkService.createLinkToken()
                window.location.href = response.data.url
            } catch {
                this.showError('Could not create a mobile app subscription link. Please try again.')
            }
        },
        async upgrade(price: Price, product: Product) {
            const priceId = price.id
            const mode = price.mode
            UserEventService.recordSafe('upgrade_clicked', { source: 'pricing', mode })
            if(!store.getters.isUserLoggedIn) {
                this.suppressCloseFeedback = true
                store.commit('showingPricingDialog', false)
                this.initialLoginOperation = 1
                this.initialLoginWantsToUpgrade = true
                this.reopenPricingAfterLogin = true
                await this.$nextTick()
                this.dialog = 'login'
                this.showInfo('Thanks! Please create an account first or login.')
                return
            }

            try {
                this.priceIdUpgrading = priceId
                const stripeKey = 'pk_live_51H8mf9H4u4N68KOCj4XAC5OYTGOYazN9aP1lnQMm8TWTbw9n11KY5hmqwpd5OCmNAja010R58SoTPW48Vfjg7psS00dBqmRpxA'
                const stripe = (window as any).Stripe(stripeKey)
                const offeredFreeTrial = this.offerFreeTrialForPrice(price, product)
                const stripeCheckoutSession = await StripeService.createStripeCheckoutSession(mode, priceId, offeredFreeTrial)
                this.checkoutStarted = true
                UserEventService.recordSafe('checkout_started', { mode, offeredFreeTrial })
                UserEventService.recordSafe('stripe_redirect_started', { mode, offeredFreeTrial })
                stripe.redirectToCheckout({sessionId: stripeCheckoutSession.data.id}).then((result: any) => {
                    if(result.error) {
                        UserEventService.recordSafe('stripe_redirect_failed', { mode })
                        this.showError(result.error)
                    }
                }, (error: any) => {
                    UserEventService.recordSafe('stripe_redirect_failed', { mode })
                    this.priceIdUpgrading = null
                    this.showError(error?.message || 'Could not open Stripe checkout.')
                })
            } catch(error) {
                UserEventService.recordSafe('checkout_creation_failed', {
                    mode,
                    status: (error as any)?.response?.status ?? null
                })
                this.priceIdUpgrading = null
                this.showError('An error occurred subscribing.')
            } finally {
                setTimeout(() => this.priceIdUpgrading = null, 5000)
            }
        }
    }
})
</script>
